import config from "../config/mapconfig";
import MarkerClusterer from "@google/markerclusterer";

export default class Map {
    constructor(elem, locations, zoom) {
        this.elements = {
            map: elem.querySelector(".js-map-elem"),
            legend: elem.querySelector(".js-map-legend")
        };

        if (!this.elements.map || !window.google) {
            return;
        }

        // SET DEFAULT VARIABLE
        this.settings = {
            zoom: zoom
        };

        this.iconStyles = [];

        this.defaultMarkerIcon = {
            url: "./_resources/themes/staete/gfx/map/marker-icon-brand-ter.svg",
            scaledSize: new google.maps.Size(25, 35), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(12, 35) // anchor
        };

        this.koopMarkerIcon = { ...this.defaultMarkerIcon };
        this.iconStyles.push({ name: "Koop", icon: this.koopMarkerIcon });

        this.huurMarkerIcon = { ...this.defaultMarkerIcon };
        this.huurMarkerIcon.url =
            "./_resources/themes/staete/gfx/map/marker-icon-brand.svg";
        this.iconStyles.push({ name: "Huur", icon: this.huurMarkerIcon });

        this.nieuwbouwMarkerIcon = { ...this.defaultMarkerIcon };
        this.nieuwbouwMarkerIcon.url =
            "./_resources/themes/staete/gfx/map/marker-icon-brand-sec.svg";
        this.iconStyles.push({
            name: "Nieuwbouw",
            icon: this.nieuwbouwMarkerIcon
        });

        this.locations = locations;
        this.markers = {};

        this.bounds = new window.google.maps.LatLngBounds();

        // CREATE MAP
        this.map = new window.google.maps.Map(
            this.elements.map,
            config(this.settings.zoom, {
                lat: this.locations[0].lat,
                lng: this.locations[0].lng
            })
        );

        // CREATE MARKERS
        for (let i = 0; i < this.locations.length; i++) {
            const item = this.locations[i];

            const location = {
                lat: item.lat,
                lng: item.lng
            };

            let icon = this.defaultMarkerIcon;

            if (item.type === "Nieuwbouw") {
                icon = this.nieuwbouwMarkerIcon;
            }

            if (item.type === "Koop") {
                icon = this.koopMarkerIcon;
            }

            if (item.type === "Huur") {
                icon = this.huurMarkerIcon;
            }

            const type = item.type ? item.type : "Default";

            if (!this.markers.hasOwnProperty(type)) {
                this.markers[type] = [];
            }

            this.createMarker(location, type, icon, item);
        }

        if (this.elements.legend) {

            const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

            if (viewportWidth > 767) {
                this.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(
                    this.elements.legend
                );
            }

            for (let i = 0; i < this.iconStyles.length; i++) {
                const style = this.iconStyles[i];
                const name = style.name;

                if (this.markers[name]) {
                    const icon = style.icon;
                    let button = document.createElement("button");
                    button.classList.add("map-legend__item", "is--active");
                    button.innerHTML =
                        `<img class="map-legend__icon" src="${icon.url}" />
                        <span class="map-legend__label">${name} (${this.markers[name].length})</span>`;

                    this.elements.legend.appendChild(button);

                    button.addEventListener('click', () => this.filterType(name, button));
                }
            }
        }

        this.markerCluster = new MarkerClusterer(this.map, [], {
            averageCenter: true,
            imagePath: "./_resources/themes/staete/gfx/map/m"
        });

        this.filterType = this.filterType.bind(this);

        this.clusterMarkers();
        this.mapFitBounds();
    }

    filterType(type, button) {
        let map;

        if (button.classList.contains('is--active')) {
            map = null;
            button.classList.remove('is--active');
        } else {
            map = this.map;
            button.classList.add('is--active');
        }

        for (let i = 0; i < this.markers[type].length; i++) {
            const marker = this.markers[type][i];
            marker.setMap(map);
        }

        if (map === null) {
            this.removeMarkersFromCluster(this.markers[type]);
        } else {
            this.addMarkersToCluster(this.markers[type]);
        }

        this.mapFitBounds();
    }

    clusterMarkers() {
        const allMarkers = [];
        const keys = Object.keys(this.markers);
        for (const key of keys) {
            for (let i = 0; i < this.markers[key].length; i++) {
                if (key != "Default") {
                    const marker = this.markers[key][i];
                    if (marker.getMap()) {
                        allMarkers.push(marker);
                    }
                }
            }
        }

        this.markerCluster.addMarkers(allMarkers);
    }

    addMarkersToCluster(markers) {
        this.markerCluster.addMarkers(markers);
    }

    removeMarkersFromCluster(markers) {
        this.markerCluster.removeMarkers(markers);
    }

    mapFitBounds() {
        // FITBOUNDS WHEN MORE THAN 1 MARKERS
        if (this.locations.length > 1) {
            this.map.fitBounds(this.bounds);
            this.map.panToBounds(this.bounds);
        }
    }

    createMarker(location, type, icon, obj) {
        const marker = new window.google.maps.Marker({
            map: this.map,
            position: location,
            icon: icon
        });

        this.markers[type].push(marker);

        this.bounds.extend(location);
    }
}
